import { render, staticRenderFns } from "./KeywordForm.vue?vue&type=template&id=68b187a1&"
import script from "./KeywordForm.js?vue&type=script&lang=js&"
export * from "./KeywordForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports